import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import PT from 'prop-types';
import styled from 'styled-components';
import { a as TaktIdProvider, w as withTaktFallbackId } from '../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';
import { I as Icon } from '../Icon/Icon-rcwnFk3r.js';
import { f as angleUp, g as angleDown } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-EM4gOTGb-B7bhIt-r.js';
import { T as TextButton } from '../Button/TextButton/TextButton-DtuYaopu.js';

const IconWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30065889__sc-1yohf31-0"
})(["display:flex;color:", ";width:14px;flex:0 0 auto;padding-inline-end:", ";padding-inline-start:0;"], ({
  theme
}) => theme.icon.color, ({
  theme
}) => theme.spacing.mini);
const StyledTextButton = /*#__PURE__*/styled(TextButton).withConfig({
  componentId: "sc-storm-ui-30065889__sc-1yohf31-1"
})(["display:inline-flex;justify-content:flex-start;align-items:stretch;text-align:initial;:hover{> ", "{color:", ";}}"], IconWrapper, ({
  theme
}) => theme.icon.hover.color);
StyledTextButton.displayName = 'ExtenderButton';
const ExtenderButtonWithTaktFallback = withTaktFallbackId(StyledTextButton);
const ExtenderButton = /*#__PURE__*/styled(ExtenderButtonWithTaktFallback).withConfig({
  componentId: "sc-storm-ui-30065889__sc-1yohf31-2"
})([""]);
const TextButtonLabel = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30065889__sc-1yohf31-3"
})(["flex:1 1 auto;"]);
const RenderEndWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30065889__sc-1yohf31-4"
})(["display:inline-block;"]);
const InlineExpanderContent = /*#__PURE__*/styled('section').withConfig({
  componentId: "sc-storm-ui-30065889__sc-1yohf31-5"
})(["display:", ";padding-inline-start:", ";padding-inline-end:0;"], ({
  isOpen
}) => isOpen ? 'block' : 'none', ({
  theme
}) => theme.spacing.base);
InlineExpanderContent.displayName = 'InlineExpanderContent';
// eslint-disable-next-line max-len
const InlineExpander = ({
  children,
  label,
  handleClick,
  isOpen,
  renderEnd,
  taktId,
  taktValue,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdProvider, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('inline-expander')
}, /*#__PURE__*/React__default.createElement(ExtenderButton, _extends({
  onClick: handleClick,
  tabindex: "0",
  "aria-expanded": isOpen,
  taktFallbackId: createStormTaktId(isOpen ? 'close-button' : 'open-button')
}, rest), /*#__PURE__*/React__default.createElement(IconWrapper, null, isOpen ? /*#__PURE__*/React__default.createElement(Icon, {
  type: angleUp
}) : /*#__PURE__*/React__default.createElement(Icon, {
  type: angleDown
})), /*#__PURE__*/React__default.createElement(TextButtonLabel, null, label)), renderEnd && /*#__PURE__*/React__default.createElement(RenderEndWrapper, null, renderEnd()), /*#__PURE__*/React__default.createElement(InlineExpanderContent, _extends({}, rest, {
  isOpen: isOpen
}), children));
InlineExpander.defaultProps = {
  handleClick: () => undefined,
  renderEnd: () => undefined
};
InlineExpander.propTypes = {
  /**
   * The content within the InlineExpander.
   */
  children: PT.node.isRequired,
  /**
   * The InlineExpander Button label.
   */
  label: PT.node.isRequired,
  /**
   * Denotes if the InlineExapnder is open or closed.
   */
  isOpen: PT.bool.isRequired,
  /**
   * The click event handler. Used to toggle state.
   */
  handleClick: PT.func,
  /**
   * Renders the content after the label
   */
  renderEnd: PT.func
};

export { InlineExpander as I };
//# sourceMappingURL=InlineExpander-C6VR9XFd.js.map
